import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Image from '../../components/AppImage';

import extraImg1 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.22.43 AM.jpeg';
import extraImg2 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.22.47 AM.jpeg';
import extraImg3 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.22.49 AM.jpeg';
import extraImg4 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.22.58 AM.jpeg';
import extraImg5 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.23.01 AM.jpeg';
import extraImg6 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.23.06 AM.jpeg';
import extraImg7 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.23.28 AM.jpeg';
import extraImg8 from '../../../additional-images-to-portfolio_page/WhatsApp Image 2026-01-20 at 10.23.30 AM.jpeg';

const allImages = [
  { src: "/assets/images/elevator-products/classic-gold-molding.jpg", title: "Classic Gold Molding", category: "Luxury" },
  { src: "/assets/images/elevator-products/gold-brass-doors.jpg", title: "Gold Brass Doors", category: "Premium" },
  { src: "/assets/images/elevator-products/gold-interior-narrow.jpg", title: "Gold Interior Narrow", category: "Residential" },
  { src: "/assets/images/elevator-products/gold-single-plant.jpg", title: "Gold Single Plant Design", category: "Boutique" },
  { src: "/assets/images/elevator-products/home-lift-stairs.jpg", title: "Home Lift Integration", category: "Residential" },
  { src: "/assets/images/elevator-products/modern-glass-shaft.jpg", title: "Modern Glass Shaft", category: "Panoramic" },
  { src: "/assets/images/elevator-products/modern-lobby-wood.jpg", title: "Modern Lobby Wood Finish", category: "Commercial" },
  { src: "/assets/images/elevator-products/panoramic-city-view.jpg", title: "Panoramic City View", category: "Panoramic" },
  { src: "/assets/images/elevator-products/residential-glass-lift.jpg", title: "Residential Glass Lift", category: "Residential" },
  { src: "/assets/images/elevator-products/silver-lobby.jpg", title: "Silver Lobby Modern", category: "Commercial" },
  { src: "/assets/images/elevator-products/wood-luxury-door.jpg", title: "Wood Luxury Door", category: "Luxury" },
  { src: extraImg1, title: "Modern Luxury Lobby", category: "Commercial" },
  { src: extraImg2, title: "Gold Glass Residential Lift", category: "Residential" },
  { src: extraImg3, title: "Luxury Gold-Finish Elevator", category: "Luxury" },
  { src: extraImg4, title: "Gold Decorative Interior", category: "Premium" },
  { src: extraImg5, title: "Minimalist Glass Solution", category: "Boutique" },
  { src: extraImg6, title: "Stairwell Glass Integration", category: "Residential" },
  { src: extraImg7, title: "Industrial Glass Duplex", category: "Panoramic" },
  { src: extraImg8, title: "Bronze Modern Elevator", category: "Commercial" }
];

const categories = ["All", "Luxury", "Premium", "Residential", "Commercial", "Panoramic", "Boutique"];

const ProjectPortfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState("All");
  const [filteredImages, setFilteredImages] = useState(allImages);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (activeFilter === "All") {
      setFilteredImages(allImages);
    } else {
      setFilteredImages(allImages.filter(img => img.category === activeFilter));
    }
  }, [activeFilter]);

  return (
    <>
      <Helmet>
        <title>Project Portfolio | VASTECH Excellence Showcase</title>
        <meta name="description" content="Explore our curated gallery of premium engineering projects, featuring advanced elevator installations and smart building solutions." />
      </Helmet>

      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-[#91756A]/30">
        <Header />

        {/* Hero Section */}
        <section className="relative pt-40 pb-20 px-4 overflow-hidden bg-slate-50">
          <div className="absolute top-0 right-0 w-1/3 h-full bg-[#91756A]/5 skew-x-12 translate-x-20"></div>
          
          <div className="container mx-auto relative z-10 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="flex items-center justify-center space-x-3 text-[#91756A] mb-8">
                <div className="w-12 h-px bg-[#91756A]"></div>
                <span className="text-xs font-bold uppercase tracking-[0.5em]">Our Showcase</span>
                <div className="w-12 h-px bg-[#91756A]"></div>
              </div>
              
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#4D4C4A] leading-[1.05] mb-10 tracking-tighter italic uppercase">
                Project <br />
                <span className="text-[#91756A]">Portfolio</span>
              </h1>
              
              <p className="text-slate-500 text-lg md:text-xl max-w-2xl mx-auto italic font-light leading-relaxed">
                A curated collection of our most prestigious installations, where precision engineering meets architectural elegance.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Filter Bar - Hidden for now */}
        {/* 
        <section className="sticky top-20 z-40 bg-white/80 backdrop-blur-md border-y border-slate-100 py-6">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center gap-4 md:gap-8">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveFilter(cat)}
                  className={`text-xs font-bold uppercase tracking-[0.2em] transition-all duration-300 relative py-2 ${
                    activeFilter === cat ? "text-[#91756A]" : "text-slate-400 hover:text-[#4D4C4A]"
                  }`}
                >
                  {cat}
                  {activeFilter === cat && (
                    <motion.div
                      layoutId="filter-underline"
                      className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#91756A]"
                    />
                  )}
                </button>
              ))}
            </div>
          </div>
        </section>
        */}

        {/* Portfolio Grid */}
        <section className="py-20 px-4 min-h-screen">
          <div className="container mx-auto">
            <motion.div 
              layout
              className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8"
            >
              <AnimatePresence mode='popLayout'>
                {filteredImages.map((image, index) => (
                  <motion.div
                    key={image.src}
                    layout
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.5, delay: index * 0.05 }}
                    className="relative group cursor-pointer break-inside-avoid overflow-hidden bg-slate-100"
                    onClick={() => setSelectedImage(image)}
                  >
                    <div className="relative overflow-hidden aspect-auto">
                      <Image
                        src={image.src}
                        alt={image.title}
                        className="w-full h-auto transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105"
                      />
                      
                      {/* Premium Hover Overlay */}
                      <div className="absolute inset-0 bg-[#4D4C4A]/60 opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col justify-end p-8">
                        <motion.span 
                          className="text-[#91756A] text-[10px] font-bold uppercase tracking-[0.3em] mb-2 block"
                          initial={{ x: -20, opacity: 0 }}
                          whileInView={{ x: 0, opacity: 1 }}
                        >
                          {image.category}
                        </motion.span>
                        <h3 className="text-white text-2xl font-bold italic tracking-tighter uppercase leading-tight">
                          {image.title}
                        </h3>
                        <div className="mt-6 w-10 h-1 bg-[#91756A] transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-200"></div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </motion.div>
          </div>
        </section>

        {/* Full Screen Lightbox */}
        <AnimatePresence>
          {selectedImage && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-12 bg-white/95 backdrop-blur-xl"
              onClick={() => setSelectedImage(null)}
            >
              <button 
                className="absolute top-10 right-10 text-[#4D4C4A] hover:text-[#91756A] transition-colors z-[110]"
                onClick={() => setSelectedImage(null)}
              >
                <Icon name="X" size={40} strokeWidth={1} />
              </button>

              <motion.div
                initial={{ scale: 0.95, opacity: 0, y: 20 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.95, opacity: 0, y: 20 }}
                className="relative max-w-6xl w-full flex flex-col items-center"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="relative group max-h-[75vh] overflow-hidden shadow-2xl">
                  <Image
                    src={selectedImage.src}
                    alt={selectedImage.title}
                    className="max-w-full h-auto object-contain"
                  />
                </div>
                
                <div className="mt-12 text-center">
                  <span className="text-[#91756A] font-bold uppercase tracking-[0.4em] text-xs mb-4 block">
                    {selectedImage.category}
                  </span>
                  <h2 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] italic tracking-tighter uppercase leading-tight">
                    {selectedImage.title}
                  </h2>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Call to Action */}
        <section className="py-32 bg-[#4D4C4A] text-white relative overflow-hidden">
          <div className="container mx-auto px-4 relative z-10 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-4xl md:text-6xl font-bold italic tracking-tighter uppercase mb-12">
                Ready to Create Your <br />
                <span className="text-[#91756A]">Masterpiece?</span>
              </h2>
              <div className="flex flex-col sm:flex-row justify-center gap-6">
                <Button
                  variant="default"
                  className="bg-[#91756A] hover:bg-[#a1857a] text-white px-12 py-8 rounded-none text-sm font-bold uppercase tracking-[0.3em] h-auto group"
                  onClick={() => window.location.href = '/contact-consultation'}
                >
                  Start Consultation
                  <Icon name="ArrowRight" size={16} className="ml-3 group-hover:translate-x-2 transition-transform duration-300" />
                </Button>
                <Button
                  variant="outline"
                  className="border-white/20 text-white hover:bg-white/5 px-12 py-8 rounded-none text-sm font-bold uppercase tracking-[0.3em] h-auto"
                  onClick={() => window.location.href = '/about-vastech'}
                >
                  Our Philosophy
                </Button>
              </div>
            </motion.div>
          </div>
          
          {/* Decorative Background Icon */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.03] pointer-events-none">
            <Icon name="Layout" size={600} />
          </div>
        </section>

        {/* Minimalistic Footer */}
        <footer className="bg-white text-[#4D4C4A] py-12 border-t border-slate-100">
          <div className="container mx-auto px-4 text-center">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#91756A] rounded-sm flex items-center justify-center">
                <span className="text-white font-bold text-lg">V</span>
              </div>
              <h3 className="text-xl font-bold tracking-tighter italic uppercase">VASTECH</h3>
            </div>
            <p className="text-xs text-slate-400 uppercase tracking-[0.5em] mb-8 font-bold">Engineering Excellence &copy; {new Date()?.getFullYear()}</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ProjectPortfolio;